import { useMutation, useQuery } from "@apollo/react-hooks";
import { Button, Tabs, Typography } from "antd";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Fragment } from "react/cjs/react.production.min";
import PaymentImage from "../../../../../Assets/Images/006.jpg";
import { Loader } from "../../../../../Components/Loader";
import { CustIcon } from "../../../../../Components/Svgs";
import { UPDATE_USER_LAST_SCREEN } from "../../../../../Graphql/mutations";
import {
  GET_PRICE_PACKAGES,
  GET_PRICE_PACKAGES_LIST,
} from "../../../../../Graphql/queries";
import "./SelectPackage.less";

const { Title } = Typography;
const { TabPane } = Tabs;

export const SelectPackage = () => {
  const history = useHistory();

  const { data: pricePackageData, loading: pricePackageLoading } = useQuery(
    GET_PRICE_PACKAGES,
    {
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );
  const { data: PackageData, loading: packageLoading } = useQuery(
    GET_PRICE_PACKAGES_LIST,
    {
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  useEffect(() => {
    UPDATE_USER_LAST_SCREEN_MUTATION({
      variables: {
        user_id: localStorage.getItem("user_id"),
        last_screen: history.location.pathname,
      },
    });
  }, []);
  const getTabData = () => {
    if (!PackageData) {
      return {};
    }
    return PackageData.packages.reduce((acc, curr) => {
      let formatAcc = acc;
      curr.package_prices.forEach((singlePackage) => {
        if (!formatAcc.hasOwnProperty(singlePackage.billing_period)) {
          formatAcc[singlePackage.billing_period] = [];
        }
        formatAcc[singlePackage.billing_period].push({
          free_trial_days: singlePackage.free_trial_days,
          price: singlePackage.price,
          stripe_price_id: singlePackage.stripe_price_id,
          allow_custom_task: curr.allow_custom_task,
          allow_qr_code: curr.allow_qr_code,
          billing_period: singlePackage.billing_period,
          name: curr.name,
          alternate_plan:
            singlePackage.billing_period === "Yearly"
              ? curr.package_prices.filter(
                  ({ billing_period }) => billing_period === "Monthly"
                )[0]
              : curr.package_prices.filter(
                  ({ billing_period }) => billing_period === "Yearly"
                )[0],
        });
      });
      return formatAcc;
    }, {});
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={PaymentImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight paymentPlanRightSection">
        {pricePackageLoading ? (
          <Loader />
        ) : (
          <div className="step_6">
            <p className="text-right text-step">Step 4 of 6</p>
            <div className="pl-4">
              <Title level={2}>
                <CustIcon
                  type="left-arrow"
                  onClick={() => history.push("/on-boarding/business-details")}
                />
                Select a payment plan
              </Title>
              <p className="subTitle">
                Signup for any of our package and get{" "}
                <strong>30 days risk free trial</strong>. Upgrade or Cancel at
                any time, no questions, no hassle.
              </p>
            </div>
            <Tabs
              type="card"
              defaultActiveKey="Yearly"
              className="paymentPlanTab"
            >
              {Object.keys(getTabData()).map((singleValue) => {
                return (
                  <TabPane tab={singleValue} key={singleValue}>
                    <div className="listPlan">
                      {getTabData()[singleValue].map((singlePackage, index) => {
                        return (
                          <PlanElement
                            key={singlePackage.name}
                            index={index}
                            publishableKey={
                              pricePackageData.get_stripe_setup.publishableKey
                            }
                            {...singlePackage}
                          />
                        );
                      })}
                    </div>
                  </TabPane>
                );
              })}
            </Tabs>
            <div className="pt-3 conditionApply">
              <small>
                * Please contact{" "}
                <a href="mailto:support@sanattest.com">support@sanattest.com</a>{" "}
                or <a href="tel:18337262883">1-833-726-2883</a> if you have more
                than 50 employees in 1 location.
              </small>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export const PlanElement = (singlePlan) => {
  const history = useHistory();

  return (
    <div
      // key={index}
      className={`planBox ${singlePlan?.name
        ?.toLowerCase()
        .replace(" ", "-")} plan_${singlePlan?.index}`}
    >
      <h4 className={`planName plan_${singlePlan?.index}`}>
        {singlePlan?.name}
      </h4>
      <div className="planPrice">
        <Title level={2}>
          <span>
            ${singlePlan?.price}
            <small>USD</small>
          </span>
          <p>Per location</p>
        </Title>
        <p>{singlePlan?.billing_period}</p>
      </div>
      <div className="planDetails pt-3 pb-3">
        <ul className="list-style pl-4 text-left">
          <li>Free Trial for {singlePlan?.free_trial_days} Days</li>
          <li>
            {singlePlan?.allow_custom_task} Custom tasks per employee per month
          </li>
          {singlePlan?.allow_qr_code && (
            <li>Scan QR Code to mark the task as complete</li>
          )}
          <li>Add up to 3 photos as proof of task completion</li>
        </ul>
      </div>
      <div
        className="trialDays mt-auto"
        onClick={() =>
          history.push({
            pathname: "/on-boarding/review-payment",
            state: {
              selectedPackage: singlePlan.alternate_plan,
              publishableKey: singlePlan?.publishableKey,
            },
          })
        }
      >
        Or buy at USD ${singlePlan?.alternate_plan?.price}/
        {singlePlan?.alternate_plan?.billing_period}
      </div>
      <Button
        type="primary"
        shape="round"
        htmlType="submit"
        onClick={() =>
          history.push({
            pathname: "/on-boarding/review-payment",
            state: {
              selectedPackage: singlePlan,
              publishableKey: singlePlan?.publishableKey,
            },
          })
        }
      >
        Select
      </Button>
    </div>
  );
};
